/**
 * @typedef {import('../types.js').Omission} Omission
 */
import { opening } from './opening.js';
import { closing } from './closing.js';
/** @type {Omission} */

export var omission = {
  opening: opening,
  closing: closing
};